import { useEffect, useState } from "react";

export default function AnalyticsCountry() {
  const [data, setData] = useState([]);

  useEffect(() => {
    fetch("https://backend.ysskytravel.com/api/analytics/countries")
      .then((res) => res.json())
      .then((d) => setData(d));
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-xl font-bold mb-4">Visitors by Country</h2>

      <table className="w-full border">
        <thead>
          <tr className="bg-gray-100">
            <th className="p-2 border">Country</th>
            <th className="p-2 border">Visits</th>
          </tr>
        </thead>

        <tbody>
          {data.map((row) => (
            <tr key={row.country}>
              <td className="p-2 border">{row.country}</td>
              <td className="p-2 border text-center">{row.visits}</td>
            </tr>
          ))}
        </tbody>
      </table>

    </div>
  );
}
